import { Script } from "./script";

const EXPERIMENT_URL = "https://www.google-analytics.com/cx/api.js";

export default class Experiment {
  constructor(experimentId){
    this._id = experimentId;
  }

  id(){
    return this._id;
  }

  src(){
    return EXPERIMENT_URL + "?experiment=" + this.id();
  }

  load(){
    return Script.append(this.src());
  }

  getChosenVariation(){
    if(window.cxApi){
      return window.cxApi.getChosenVariation(this.id());
    }
  }

  setChosenVariation(variation){
    if(window.cxApi){
      window.cxApi.setChosenVariation(variation, this.id());
    }
  }

  isChosen(){
    return this.getChosenVariation() >= 0;
  }

  variation(){
    return (this.isChosen()) ? this.getChosenVariation() : 0;
  }

  start(){
    var promise = new Promise(function(resolve, reject){
      this.load().then(function(){
        window.cxApi.chooseVariation();
        resolve();
      }).catch(function(){
        reject();
      });
    }.bind(this));

    return promise;
  }
}
